import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    appVersion: process.env.VUE_APP_VERSION,
    windowWidth: window.innerWidth,
    selectedPage: {
      text: '',
      value: '',
    },
    searchBy: {
      providerAccountId: '',
      houseNumber: '',
      accountNumber: '',
    }
  },
  mutations: {
    setWindowWidth(state) {
      state.windowWidth = window.innerWidth;
    },
    setSelectedPage(state, data) {
      state.selectedPage = data;
    },
    setSearchBy(state, data) {
      state.searchBy = data;
    }
  },
  actions: {
  },
  modules: {
  }
})
